import {useTranslation} from "react-i18next";

import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";
import MenuButtons from "components/MenuButtons";


const MainHistoric = () => {

  const [t] = useTranslation("routes")

  const bread = [
    {name: t("labels.advanced"), current: true},

  ]


  return (
    <>
      <NavBreadcrum navs={navs} bread={bread}/>
      <MenuButtons navs={navs}/>
    </>
  )
}
export default MainHistoric;